import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const ARROW_SVG = 'https://cdn.magicpatterns.com/uploads/1GoXLHaQZVoYF4wqdDEMeB/sj-website-arrow.svg';
export function ServicesSection() {
  const services = ['Commercial Cleaning', 'Basic Home Cleaning', 'Spring / Deep Cleaning', 'Move-in / Move-out', 'Post Renovation'];
  return <section id="services" className="bg-primary py-24 md:py-32 relative z-20 overflow-hidden" data-id="element-303">
      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-304">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-305">
          {/* Left List */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1" data-id="element-306">
            <ul className="space-y-6" data-id="element-307">
              {services.map((service, index) => <li key={index} className="group cursor-pointer" data-id="element-308">
                  <div className="flex items-center gap-6 py-4 border-b border-white/20 group-hover:border-white/60 transition-colors duration-300" data-id="element-309">
                    <span className="text-sm font-bold text-white/40 group-hover:text-white/80 transition-colors" data-id="element-310">
                      0{index + 1}
                    </span>
                    <h3 className="text-2xl md:text-3xl font-heading font-medium text-white uppercase tracking-wide group-hover:translate-x-4 transition-transform duration-300" data-id="element-311">
                      {service}
                    </h3>
                    <img src={ARROW_SVG} alt="" className="ml-auto w-8 h-4 opacity-0 group-hover:opacity-100 transition-all duration-300 -translate-x-4 group-hover:translate-x-0 brightness-0 invert" data-id="element-312" />
                  </div>
                </li>)}
            </ul>
          </motion.div>

          {/* Right Content */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-1 lg:order-2 flex flex-col items-end text-right" data-id="element-313">
            <h2 className="text-6xl md:text-8xl lg:text-9xl font-heading font-bold text-white uppercase leading-[0.85] tracking-tighter mb-12" data-id="element-314">
              Our <br data-id="element-315" /> Services
            </h2>

            <div className="relative w-full max-w-md h-[400px] rounded-2xl overflow-hidden shadow-xl" data-id="element-316">
              <img src="https://cdn.magicpatterns.com/uploads/mk5jPpVrzEXkVMT38VvRsz/clean-home-sj.jpg" alt="Professional apartment cleaning" loading="lazy" className="w-full h-full object-cover" data-id="element-317" />
              <div className="absolute inset-0 bg-primary/10 hover:bg-transparent transition-colors duration-500" data-id="element-318"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}